"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LoadableApp = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _Utilities = require("@fluentui/react/lib/Utilities");

var React = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _LoadingBanner = require("../../Banners/LoadingBanner");

var _ErrorBoundary = require("../../Errors/ErrorBoundary/ErrorBoundary");

var _ConfirmationDialog = require("../../Notifications/ConfirmationDialog");

var _dialogRegistry = require("../../Notifications/dialogRegistry");

var _ConnectedDialogSwitch = require("../../Notifications/DialogSwitch/ConnectedDialogSwitch");

var _ToastNotification = require("../../Notifications/ToastNotification");

var _SkipToMainContent = require("../../SkipToMainContent/SkipToMainContent");

var _MeControl = require("../../User/MeControl");

var _UserActions = require("../../User/models/UserActions");

var _TenantPicker = require("../../User/TenantPicker");

var _AuthenticatedContent = require("../AuthenticatedContent");

var _ConnectedStandardAppBar = require("../ConnectedStandardAppBar");

var _RoutedNav = require("../RoutedNav");

var styles = require('../../styling/patterns/App.scoped.scss');

if (process.env.APP_DISABLE_GLOBAL_STYLES !== 'true') {
  require('../../styling/patterns/Global.scoped.scss');
}

var LoadableApp = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(LoadableApp, _React$Component);

  var _super = (0, _createSuper2.default)(LoadableApp);

  function LoadableApp() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, LoadableApp);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));

    _this._renderAppBar = function () {
      var _this$props = _this.props,
          getAppTitle = _this$props.getAppTitle,
          getWaffleHeaderText = _this$props.getWaffleHeaderText,
          filterItems = _this$props.filterItems,
          t = _this$props.t,
          appBarProps = _this$props.appBarProps,
          suiteHeader = _this$props.suiteHeader;
      var appTitle = getAppTitle && getAppTitle();

      if (suiteHeader) {
        return suiteHeader;
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConnectedStandardAppBar.ConnectedStandardAppBar, (0, _objectSpread2.default)({
        appTitle: appTitle,
        t: t,
        waffleHeaderText: getWaffleHeaderText ? getWaffleHeaderText() : undefined,
        filterItems: filterItems,
        appStateKey: _this.props.appStateKey
      }, appBarProps));
    };

    _this._renderNav = function () {
      var _this$props2 = _this.props,
          history = _this$props2.history,
          getNav = _this$props2.getNav,
          navProps = _this$props2.navProps;
      var groups = getNav ? getNav() : [];
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RoutedNav.ConnectedNav, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, navProps), {}, {
        groups: groups,
        history: history
      }));
    };

    _this._renderRoute = function (routeProps) {
      return function (props) {
        var _this$props3 = _this.props,
            isLoading = _this$props3.isLoading,
            loadingText = _this$props3.loadingText,
            isBooting = _this$props3.isBooting;

        if (!routeProps.component) {
          throw 'component is required';
        }

        if (routeProps.anonymous) {
          if (isLoading && isBooting) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingBanner.LoadingBanner, {});
          } else {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(routeProps.component, (0, _objectSpread2.default)({}, props));
          }
        }

        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AuthenticatedContent.ConnectedAuthenticatedContent, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this.props.authorizationProps), {}, {
          loadingText: loadingText,
          isLoading: isLoading !== null && isLoading !== void 0 ? isLoading : false,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(routeProps.component, (0, _objectSpread2.default)({}, props))
        }));
      };
    };

    return _this;
  }

  (0, _createClass2.default)(LoadableApp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var boot = this.props.boot;

      if (boot) {
        boot();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _context2,
          _context3;

      var _this$props4 = this.props,
          accountUrl = _this$props4.accountUrl,
          appBarRoutes = _this$props4.appBarRoutes,
          navRoutes = _this$props4.navRoutes,
          t = _this$props4.t,
          tenantPickerProps = _this$props4.tenantPickerProps,
          siteBanner = _this$props4.siteBanner,
          isLoading = _this$props4.isLoading,
          isBooting = _this$props4.isBooting;
      var routes = this.props.routes;

      if (process.env.APP_FEATURE_SECURITY_ENABLE_IFRAME !== 'true') {
        if (window !== top) {
          // We do not render when not the top iframe by default
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            "data-automation-id": "not-top-frame",
            children: t('An unexpected error has occurred')
          });
        }
      }

      var fallBackRoute;
      var renderedRoutes = (0, _reduce.default)(routes).call(routes, function (routesToAdd, routeProps, routeIndex) {
        if (routeProps.path === '/') {
          var fallbackRouteProps = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, routeProps), {}, {
            path: undefined
          });
          fallBackRoute = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, fallbackRouteProps), {}, {
            component: undefined,
            render: _this2._renderRoute(fallbackRouteProps)
          }), routeIndex);
        }

        routesToAdd.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, routeProps), {}, {
          component: undefined,
          render: _this2._renderRoute(routeProps)
        }), routeIndex));
        return routesToAdd;
      }, []);

      if (fallBackRoute) {
        renderedRoutes.push(fallBackRoute);
      } else {
        renderedRoutes.push( /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
          component: undefined,
          render: this._renderRoute({
            component: function component() {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {});
            }
          })
        }, "default"));
      }

      if (isLoading && isBooting) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingBanner.LoadingBanner, {});
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkipToMainContent.SkipToMainContent, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Switch, {
          children: [appBarRoutes && (0, _map.default)(appBarRoutes).call(appBarRoutes, function (routeProps, routeIndex) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, (0, _objectSpread2.default)({}, routeProps), routeIndex);
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
            render: this._renderAppBar
          })]
        }), siteBanner && siteBanner(), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: (0, _Utilities.css)('ms-AppBody', styles.appBody),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Switch, {
            children: [navRoutes && (0, _map.default)(navRoutes).call(navRoutes, function (routeProps, routeIndex) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, (0, _objectSpread2.default)({}, routeProps), routeIndex);
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Route, {
              render: this._renderNav
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(React.Suspense, {
              fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingBanner.LoadingBanner, {}),
              children: [this.props.children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Switch, {
                children: renderedRoutes
              })]
            })
          })]
        }), this.props.onRenderFooter !== undefined ? this.props.onRenderFooter() : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToastNotification.ConnectedToastNotification, {
          t: t
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorBoundary.ErrorBoundary, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(React.Suspense, {
            fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingBanner.LoadingBanner, {}),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConnectedDialogSwitch.ConnectedDialogSwitch, {
              children: (0, _concat.default)(_context2 = (0, _map.default)(_context3 = _dialogRegistry.dialogRegistry.getDialogs()).call(_context3, function (item) {
                var props = {
                  dismissAction: item.dismissAction
                };
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(item.component, (0, _objectSpread2.default)({}, props), item.dialogAction);
              })).call(_context2, [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ConfirmationDialog.ConnectedConfirmationDialog, {}, "confirm"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MeControl.ConnectedMeControl, {
                accountUrl: accountUrl
              }, _UserActions.UserActions.showMe), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TenantPicker.ConnectedTenantPicker, (0, _objectSpread2.default)({}, tenantPickerProps), _UserActions.UserActions.showTenantPicker)])
            })
          })
        })]
      });
    }
  }]);
  return LoadableApp;
}(React.Component);

exports.LoadableApp = LoadableApp;